/** Optional emoji / icon hint per POI taxonomy type id (admin list + editor). */
export const POI_TYPE_ICON_BY_ID = {
  restaurant: '🍽️',
  cafe: '☕',
  bar: '🍺',
  nightlife_venue: '🎵',
  park: '🌳',
  fitness: '💪',
  coworking_space: '💼',
  cultural_venue: '🎭',
  event_venue: '📅',
  shop: '🛒'
};

export function poiTypeIcon(typeId) {
  if (!typeId || typeof typeId !== 'string') return '📍';
  return POI_TYPE_ICON_BY_ID[typeId] || '📍';
}
